module.exports = __webpack_public_path__ + "img/2.3733121d.png";